const PendingIcon = ({ className }) => (
  <div className={className}>
    <svg width='26' height='26' viewBox='0 0 24 24' fill='none'>
      <circle cx='12' cy='12' r='10' stroke='white' strokeWidth='2' />
      <path d='M12 6v6l4 2' stroke='white' strokeWidth='2' strokeLinecap='round' />
    </svg>
  </div>
);

export default PendingIcon;
